<fui-action-button [disabled]="disabled" [ngClass]="{'disabled': disabled}" [title]="title || 'wbo.common.button.ok'">
    <fui-icon [width]="12" [height]="12" [icon]="'success'"></fui-icon>
</fui-action-button>
